module.exports = __webpack_public_path__ + "25b3a7ed8e74b090df79fd8eeaa627e4.svg";